import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@/shared/api/reauth.api';
import { AppStoreTag } from '@/shared/constants/app-store-tag.constant';

export const maintenanceServiceApi = createApi({
	reducerPath: 'maintenance service',
	tagTypes: [AppStoreTag.MaintenanceTasks],
	baseQuery: baseQueryWithReauth(MAINTENANCE_API_URL),
	endpoints: () => ({}),
});
